<template>
    <div class="db_update" :class="wrapclass">
        <div class="update_title">
          <span>
            <svg xmlns="http://www.w3.org/2000/svg" width="49.998" height="45.831" viewBox="0 0 49.998 45.831">
              <g id="Group_80586" data-name="Group 80586" transform="translate(-190.003 -419)">
                <path id="Path_92393" data-name="Path 92393" d="M44.269,45.831H1.562A1.565,1.565,0,0,1,.046,43.89l1.1-4.421a7.061,7.061,0,0,1,4.633-5l8.17-2.723c.925-.39,1.565-1.977,1.669-4.273-1.048-.99-2.929-3.073-2.929-5.289a1.524,1.524,0,0,0-.052-.442,1.559,1.559,0,0,1-.754-.819,14.351,14.351,0,0,1-1.033-4.262l.048-.379a3.029,3.029,0,0,1,.9-1.523c.006-.175.017-.367.029-.569.05-1,.123-2.319.123-3.973C11.956,6.2,16.662,0,22.916,0c5.264,0,7.956,2.762,8.6,4.739,1.258.75,2.458,2.087,2.458,5.475v4.55a3.273,3.273,0,0,1,.921,1.383l.085.51a14.4,14.4,0,0,1-1.031,4.26,1.559,1.559,0,0,1-.754.819,1.474,1.474,0,0,0-.052.442c0,2.217-1.881,4.3-2.929,5.289.106,2.3.752,3.887,1.775,4.312l8.064,2.683a7.07,7.07,0,0,1,4.633,5l1.1,4.425a1.565,1.565,0,0,1-1.519,1.942M32.88,21.853l0,0Zm-19.928,0,0,0Zm-.006,0,0,0Z" transform="translate(190.003 419)" fill="#eceff3"/>
                <g id="Group_80585" data-name="Group 80585">
                  <path id="Path_92394" data-name="Path 92394" d="M35.939,13.8,25,10.084a1.536,1.536,0,0,0-1,0L13.06,13.8A1.558,1.558,0,0,0,12,15.284v8.37C12,33.87,23.4,38.837,23.889,39.043a1.553,1.553,0,0,0,1.221,0C25.6,38.835,37,33.87,37,23.654v-8.37a1.558,1.558,0,0,0-1.06-1.479Z" transform="translate(203.002 417)" fill="#4caf50"/>
                  <g id="Group_80584" data-name="Group 80584">
                    <path id="Path_92397" data-name="Path 92397" d="M35.939,13.8,25,10.084a1.536,1.536,0,0,0-1,0L13.06,13.8A1.558,1.558,0,0,0,12,15.284v8.37C12,33.87,23.4,38.837,23.889,39.043a1.553,1.553,0,0,0,1.221,0C25.6,38.835,37,33.87,37,23.654v-8.37a1.558,1.558,0,0,0-1.06-1.479Z" transform="translate(203.002 417)" fill="#4caf50"/>
                    <path id="Path_92396" data-name="Path 92396" d="M25.2,16.625l-4.463,5.68a1.624,1.624,0,0,1-2.332.23L15.567,20.1a1.622,1.622,0,0,1,2.111-2.464l1.555,1.332,3.416-4.348a1.622,1.622,0,0,1,2.553,2Z" transform="translate(207.746 423.999)" fill="#fff"/>
                  </g>
                </g>
              </g>
            </svg>                     
          </span>
          <label>Assign the Authorized Representative
            <small>Employer requested you to suggest an Authorized Representative for your I-9 form.</small>
            <small>Initiated on 1/23/2024</small>
          </label>
        </div>
        <div class="update_actions">
          <button class="btn theme_btn">Assign Authorized Representative</button>
        </div>
    </div>
</template>
<script> 
    export default {
        components:{
            
        },
        props: {
            wrapclass:{}
             
        }
        
    }


</script>